import React, { createElement } from 'react';
export function LogoScroll() {
  // Using actual logo URLs from popular CDNs
  const logos = [{
    name: 'Microsoft',
    url: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg'
  }, {
    name: 'ChatGPT',
    url: 'https://upload.wikimedia.org/wikipedia/commons/0/04/ChatGPT_logo.svg'
  }, {
    name: 'Anthropic',
    url: 'https://cdn.magicpatterns.com/uploads/b3LbCN9MKHzoyEwb4yc5mQ/anthropic.png'
  }, {
    name: 'Squirro',
    url: 'https://cdn.magicpatterns.com/uploads/9WTaqax8VZiXd3JsinVmWh/squirro_logo_normal_color-1.png'
  }, {
    name: 'Perplexity',
    url: 'https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/perplexity-ai-icon.png'
  }, {
    name: 'Copilot',
    url: 'https://cdn.magicpatterns.com/uploads/eyVGgbtpL9DBn4GThx3xHz/Microsoft-Copilot-Logo.png'
  }, {
    name: 'Claude',
    url: 'https://cdn.magicpatterns.com/uploads/9QYT7qABxQagKMcqUXxCu4/claude-color.png'
  }, {
    name: 'Gemini',
    url: 'https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg'
  }, {
    name: 'Salesforce',
    url: 'https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg'
  }, {
    name: 'Slack',
    url: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/Slack_icon_2019.svg'
  }];
  // Duplicate the logos array for seamless infinite scroll
  const duplicatedLogos = [...logos, ...logos];
  return <section className="w-full border-t border-gray-200 bg-white overflow-hidden" data-id="element-964">
      {/* Content-width container with fade effects */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24" data-id="element-965">
        <div className="relative py-8 overflow-hidden" data-id="element-966">
          {/* Fade effect on edges - constrained to content width */}
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white via-white to-transparent z-10 pointer-events-none" data-id="element-967"></div>
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white via-white to-transparent z-10 pointer-events-none" data-id="element-968"></div>

          {/* Scrolling container - using inline-flex for proper width calculation */}
          <div className="inline-flex animate-scroll" data-id="element-969">
            {duplicatedLogos.map((logo, index) => <div key={`logo-${index}`} className="flex-shrink-0 mx-8 flex items-center justify-center" data-id="element-970">
                <img src={logo.url} alt={logo.name} className="h-10 w-auto opacity-60 grayscale-0" onError={e => {
              // Fallback to text if image fails to load
              e.currentTarget.style.display = 'none';
              const span = document.createElement('span');
              span.textContent = logo.name;
              span.className = 'text-gray-400 font-medium text-sm';
              e.currentTarget.parentElement?.appendChild(span);
            }} data-id="element-971" />
              </div>)}
          </div>
        </div>

        {/* Bottom border with fade effect - content width */}
        <div className="relative h-px" data-id="element-972">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent" data-id="element-973"></div>
        </div>
      </div>

      <style data-id="element-974">{`
        @keyframes scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          animation: scroll 19.2s linear infinite;
          will-change: transform;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>;
}